{
  "#ABAU_INVOICE_LINK": {
    "TITLE": "Verknüpfungstool",
    "COUNT": "{{count}} Belege",
    "COUNT_OF": "{{count}} von {{total}} Belegen",
    "LINK": "Verknüpfen",
    "CLEAR_SELECTION": "Auswahl aufheben",
    "OPEN_ARCHIVE": "Archivbeleg öffnen",
    "OPEN_FILTER": "Filter",
    "INVOICES": {
      "TITLE": "Eingangsrechnungen"
    },
    "DELIVERY_NOTES": {
      "TITLE": "Lieferscheine"
    },
    "COLUMNS": {
      "DOCUMENT_NUMBER": "Belegnr.",
      "REFERENCE_NUMBER": "Bezugsnr.",
      "DOCUMENT_DATE": "Belegdatum",
      "SUPPLIER": "Lieferant",
      "HEAD_OFFICE": "Mitglied",
      "DELIVERY_ADDRESS": "Baustelle",
      "NET_AMOUNT": "Netto",
      "ENTRY_COUNT": "Pos.",
      "ARCHIVE": "Archiv",
      "LINK_MARK": ""
    },
    "FILTER": {
      "SUPPLIER": "Lieferant",
      "DELIVERY_ADDRESS": "Baustelle",
      "HEAD_OFFICE": "Mitglied",
      "DATE_RANGE": "Zeitraum",
      "NET_RANGE": "Netto €",
      "NET_FROM": "Netto von",
      "NET_TO": "Netto bis",
      "MIN_ENTRY_COUNT": "Positionen ab",
      "NET_FROM_PLACEHOLDER": "von",
      "NET_TO_PLACEHOLDER": "bis",
      "DATE_KIND": "Datumsart",
      "DATE_KIND_DOCUMENT": "Belegdatum",
      "DATE_KIND_PERIOD": "Abrechnungsdatum",
      "DATE_KIND_CREATION": "Erfassungsdatum",
      "PERIOD_ALL": "Alle Belege",
      "PRESET_LAST_WEEK": "Letzte Woche",
      "PRESET_LAST_30_DAYS": "Letzte 30 Tage",
      "PRESET_LAST_2_MONTHS": "Letzte 2 Monate",
      "PRESET_LAST_3_MONTHS": "Letzte 3 Monate",
      "BACK": "Zurück",
      "RESTRICTIONS": "Einschränkungen",
      "ALL_VALUES": "Alle",
      "REMOVE_RESTRICTION": "Einschränkung entfernen",
      "ENTRY_COUNT_CHIP": "Positionen ab {{value}}",
      "NET_CHIP_RANGE": "Netto {{from}} – {{to}} €",
      "NET_CHIP_FROM": "Netto ab {{value}} €",
      "NET_CHIP_TO": "Netto bis {{value}} €",
      "SOURCE_INVOICES_EXTRA": "Eingangsrechnungen – Einschränkungen",
      "SOURCE_DELIVERY_NOTES_EXTRA": "Lieferscheine – Einschränkungen",
      "RESET": "Zurücksetzen",
      "APPLY": "Übernehmen"
    },
    "ASSIGNMENT": {
      "TITLE": "Aktuelle Zuordnung",
      "NO_INVOICE": "Keine Eingangsrechnung markiert",
      "NO_DELIVERY_NOTE": "kein Lieferschein gewählt",
      "HINT": "Links eine Eingangsrechnung wählen, rechts die zugehörigen Lieferscheine markieren (Mehrfachauswahl für Sammelrechnungen)."
    },
    "MESSAGES": {
      "NO_ARCHIVE": "Kein Archivbeleg vorhanden"
    },
    "LINKED_IN_SESSION": "In dieser Sitzung verknüpft — über „Verknüpfung lösen\" wieder lösbar",
    "DRAFT_SELECTION": "Ausgewählt — wird mit „Verknüpfen\" verknüpft",
    "UNLINK": "Verknüpfung lösen",
    "ARCHIVE_PANEL": {
      "TITLE": "Archivbeleg",
      "CLOSE": "Archivbeleg schließen"
    },
    "EXPAND_TABLE": "Tabelle vergrößern",
    "COLLAPSE_TABLE": "Tabelle verkleinern"
  },
  "DESPATCHADVICE_LINK": {
    "GENERAL": {
      "DELIVERY_NOTE_ALREADY_LINKED": "Dieser Lieferschein ist bereits mit einer anderen Eingangsrechnung verknüpft.",
      "DELIVERY_NOTE_WITHOUT_ENTRIES": "Dieser Lieferschein hat keine Positionen und kann nicht verknüpft werden.",
      "SPLIT_NOT_POSSIBLE": "Die Rechnung lässt sich nicht auf mehrere Lieferscheine aufteilen.",
      "DOCUMENT_NOT_FOUND": "Der Beleg ist nicht mehr vorhanden. Bitte die Listen neu laden.",
      "NO_DELIVERY_NOTES": "Es wurde kein Lieferschein ausgewählt.",
      "TOO_FEW_INVOICE_POSITIONS": "Die Rechnung hat nur {{invoicePositions}} Position(en) und kann daher nicht mit {{deliveryNotes}} Lieferscheinen verknüpft werden. Jeder Lieferschein braucht mindestens eine Rechnungsposition.",
      "GENERAL_ERROR": "Die Verknüpfung ist fehlgeschlagen. Bitte erneut versuchen."
    }
  }
}
